// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3qlgc","content":"Consent_content__2qJk-","footer":"Consent_footer__1kg76"};